import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchAgencies({ payload }) {
  try {
    const agencyData = [
      {
        id: "1",
        name: "Agency 1",
        company: "Company 1",
        businessType: "Business Type 1",
        registeredAddress: "Registered Address 1",
      },
      {
        id: "2",
        name: "Agency 2",
        company: "Company 2",
        businessType: "Business Type 2",
        registeredAddress: "Registered Address 2",
      },
      {
        id: "3",
        name: "Agency 3",
        company: "Company 3",
        businessType: "Business Type 3",
        registeredAddress: "Registered Address 3",
      },
      {
        id: "4",
        name: "Agency 4",
        company: "Company 4",
        businessType: "Business Type 4",
        registeredAddress: "Registered Address 4",
      },
      {
        id: "5",
        name: "Agency 5",
        company: "Company 5",
        businessType: "Business Type 5",
        registeredAddress: "Registered Address 5",
      },
      {
        id: "6",
        name: "Agency 6",
        company: "Company 6",
        businessType: "Business Type 6",
        registeredAddress: "Registered Address 6",
      },
      {
        id: "7",
        name: "Agency 7",
        company: "Company 7",
        businessType: "Business Type 7",
        registeredAddress: "Registered Address 7",
      },
      {
        id: "8",
        name: "Agency 8",
        company: "Company 8",
        businessType: "Business Type 8",
        registeredAddress: "Registered Address 8",
      },
      {
        id: "9",
        name: "Agency 9",
        company: "Company 9",
        businessType: "Business Type 9",
        registeredAddress: "Registered Address 9",
      },
      {
        id: "10",
        name: "Agency 10",
        company: "Company 10",
        businessType: "Business Type 10",
        registeredAddress: "Registered Address 10",
      },
    ];

    // const res = yield call(API.fetchAllSamplers, payload);
    // const { data } = res;
    yield put(actions.fetchAgenciesSuccess(agencyData));
  } catch (err) {
    yield put(actions.fetchAgenciesFailure(err?.response?.data));
  }
}

export function* handleFetchTotalAgencies({ payload }) {
  try {
    const totalAgencies = [
      {
        id: "1",
        name: "Agency 1",
      },
      {
        id: "2",
        name: "Agency 2",
      },
      {
        id: "3",
        name: "Agency 3",
      },
      {
        id: "4",
        name: "Agency 4",
      },
      {
        id: "5",
        name: "Agency 5",
      },
      {
        id: "6",
        name: "Agency 6",
      },
      {
        id: "7",
        name: "Agency 7",
      },
      {
        id: "8",
        name: "Agency 8",
      },
      {
        id: "9",
        name: "Agency 9",
      },
      {
        id: "10",
        name: "Agency 10",
      },
    ];

    // const res = yield call(API.fetchAllSamplers, payload);
    // const { data } = res;
    yield put(actions.fetchTotalAgenciesSuccess(totalAgencies));
  } catch (err) {
    yield put(actions.fetchTotalAgenciesFailure(err?.response?.data));
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* agencyListingSaga() {
  yield takeLatest(actions.fetchAgencies.type, handleFetchAgencies);
  yield takeLatest(actions.fetchTotalAgencies.type, handleFetchTotalAgencies);
}
